import { inEnum, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { LoginMode } from "../login/LoginMode.js";
import { UserRole } from "../login/UserRole.js";
import { AuthProviderIdentifier } from "../login/AuthProviderIdentifier.js";

/**
 * Oggetto che rappresenta una sessione
 */
export interface StorableSession {
    /**
     * token utente
     */
    token: string;
    /**
     * ruolo dell'utente in sessione (fissato a 2 - esiste per retrocompatibilità)
     */
    role: UserRole;
}



export function isStorableSession(obj: any): obj is StorableSession {
    return isObject(obj) && isString(obj.token) && inEnum(obj.role, UserRole);
}


export function isLoggedInSession(obj: any): obj is StorableSession {
    return isStorableSession(obj) && obj.role == UserRole.AUTHENTICATED_USER;
}


export function getUserIdFromSession(s: StorableSession): string | null {
    const sub = s.token.substring(0,16);
    return sub.length >= 12?sub:null;
}


export interface StorableSessionInfo {
    provider: AuthProviderIdentifier;
    loginMode: LoginMode;
    isNewUser: boolean;
}